import { SignalTypeMeta } from "@megaron/resource";

import { FulfillmentOrderDoc } from "./orderDoc";

type FulfillmentDocType = FulfillmentOrderDoc["docType"];

export const fulfillmentSignalTypes = {
  loyaltyAdminOrderCreated: {
    subjectDocType: "fulfillment-order",
    level: "info",
    app: "loyaltyAdmin",
    actionLabel: "Złożone zamówienie",
  },
} as const satisfies Record<string, SignalTypeMeta<FulfillmentDocType>>;
